import { Badge } from "@mantine/core";
import { isMachineTrackedStainType } from "../../utils/stainType";

interface StainingStatusBadgeProps {
  slide: {
    status: string;
    stain?: { stainType?: string };
    ihcQueue?: {
      status?: string;
      processedAt?: string | null;
      dispatchAttemptId?: string | null;
    } | null;
  };
}

const STATUS_LABELS: Record<string, { color: string; label: string }> = {
  ready_for_staining: { color: "yellow", label: "Ready" },
  staining_in_progress: { color: "blue", label: "Staining" },
  staining_completed: { color: "green", label: "Completed" },
  sent: { color: "cyan", label: "Sent" },
  sending: { color: "cyan", label: "Sending" },
  failed: { color: "red", label: "Failed" },
};

export function StainingStatusBadge({ slide }: StainingStatusBadgeProps) {
  const queue = slide.ihcQueue;
  let status = slide.status;
  if (
    isMachineTrackedStainType(slide.stain?.stainType) &&
    ["ready_for_staining", "staining_in_progress"].includes(status) &&
    !queue?.processedAt
  ) {
    if (queue?.dispatchAttemptId) status = "sending";
    else if (queue?.status === "distributed") status = "sent";
    else if (queue?.status === "failed") status = "failed";
  }
  const { color, label } = STATUS_LABELS[status] ?? {
    color: "gray",
    label: status,
  };
  return (
    <Badge color={color} miw="max-content">
      {label}
    </Badge>
  );
}
